import { render, staticRenderFns } from "./RemoveOrderMessage.vue?vue&type=template&id=54b59b14&"
import script from "./RemoveOrderMessage.vue?vue&type=script&lang=ts&"
export * from "./RemoveOrderMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports